import React, { useRef, useEffect } from "react";

import { Footer as StyledFooter } from "./styles";

function Footer() {
  const alertEl = useRef();

  return (
    <StyledFooter ref={alertEl} >
     © 2021 SENAI-JOB - Portal de Talentos da Indústria. Todos os direitos reservados.
    </StyledFooter>
  );
}

export default Footer;
